/**
 * Joins the city and address snapshotted onto an offer or booking item into one line.
 * Both are nullable — items created before the snapshot columns existed carry neither,
 * and a free-text accommodation may carry only what the admin typed — so callers should
 * treat an empty result as "no location to show" rather than rendering an empty label.
 */
export const formatLocation = (
  city?: string | null,
  address?: string | null
): string => [city, address].filter(Boolean).join(", ");
